<!-- <div class="d-flex" id="wrapper">
    <app-sidebar></app-sidebar>
    <div id="page-content-wrapper">
        <app-header></app-header>
        <app-notice-board></app-notice-board>
    </div>
</div>

<app-footer></app-footer> -->
<app-notice-board></app-notice-board>